import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useCurrency } from '../contexts/CurrencyContext';
import { Eye } from 'lucide-react';

const PrizeCard = ({ title, description, value, imageUrl, color, index }) => {
  const { convertPrice, getCurrencySymbol } = useCurrency();
  const valueInUSD = parseInt(value.replace(/[^0-9]/g, ''));
  const convertedValue = convertPrice(valueInUSD);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="relative group overflow-hidden rounded-2xl bg-white/80 backdrop-blur-md border border-white/20 shadow-xl hover:scale-[1.02] transition-all duration-300"
      data-testid={`prize-card-${index}`}
      style={{ minHeight: index === 0 ? '500px' : '350px' }}
    >
      <div className="absolute inset-0">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover opacity-40 group-hover:opacity-60 transition-opacity duration-300" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
      </div>

      <div className="relative h-full p-6 flex flex-col justify-end">
        <div className={`inline-block px-4 py-2 rounded-full text-white font-semibold mb-3 ${color} w-fit`}>
          {value}
        </div>
        <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
          {title}
        </h3>
        <p className="text-white/90 text-sm leading-relaxed line-clamp-3">
          {description}
        </p>
        <div className="flex items-center justify-between mt-4">
          <div className="text-lg font-bold text-secondary">
            {getCurrencySymbol()}{convertedValue}
          </div>
          <Link 
            to="/prizes" 
            className="flex items-center gap-1 text-white/80 hover:text-white text-sm transition-colors"
          >
            <Eye className="w-4 h-4" />
            <span>Détails</span>
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default PrizeCard;